import { request } from 'graphql-request';
import { API_URL } from 'appenv';
import { GraphQLV2GroupVideoCallRoomCreateInput, GraphQLV2GroupVideoCallRoomCreatePayload } from './graphql-models';

const groupVideoRoomCreateMutation = `
  mutation v2GroupVideoCallRoomCreate($input: V2GroupVideoCallRoomCreateInput!) {
    v2GroupVideoCallRoomCreate(input: $input) {
      success
      videoCallRoom {
        token
        status
      }
      roomAdmins {
        nodes {
          uuid
        }
      }
      roomMember {
        status
        isInviter
      }
      errors {
        path
        message
        type
        details {
          key
          value
        }
      }
    }
  }
`;

const createGroupVideoCallRoom = (groupVideoCallInput: GraphQLV2GroupVideoCallRoomCreateInput): Promise<GraphQLV2GroupVideoCallRoomCreatePayload> => request(
  API_URL,
  groupVideoRoomCreateMutation,
  { input: groupVideoCallInput },
).then(({ v2GroupVideoCallRoomCreate }) => v2GroupVideoCallRoomCreate);
export default createGroupVideoCallRoom;
